import { useTranslation } from 'module/hooks/use-translation';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { Switcher } from 'module/ui/components/atoms/switcher/switcher';
import { faList, faGrid2 } from '@fortawesome/pro-regular-svg-icons';
import { RadioChangeEvent, Tooltip } from 'antd';
import { FC, useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTE_PATHS } from 'routes/route-paths';
import { useAccountPeopleRouteNavigation } from 'components/organisms/account-people/route-navigation';
import { useCompanyFromUrl } from '../../pages/accounts/detail/use-current-company';

enum Tabs {
  List = 'list',
  Grid = 'grid',
}

export const AccountPeopleViewSwitcher: FC = () => {
  const { data: company } = useCompanyFromUrl();
  const { navigateToPeopleList, navigateToPeopleGrid } =
    useAccountPeopleRouteNavigation();
  const { pathname } = useLocation();
  const listViewName = useTranslation('list.view');
  const boardViewName = useTranslation('board.view');
  const [activeTab, setActiveTab] = useState<Tabs>(Tabs.List);
  const onChange = useCallback(
    (e: RadioChangeEvent) => {
      setActiveTab(e.target.value as Tabs);
      if (e.target.value === Tabs.Grid) {
        navigateToPeopleGrid(company?.companyId ?? 0);
      } else if (e.target.value === Tabs.List) {
        navigateToPeopleList(company?.companyId ?? 0);
      }
    },
    [company?.companyId, navigateToPeopleGrid, navigateToPeopleList],
  );

  useEffect(() => {
    if (pathname.includes(ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE_BOARD)) {
      setActiveTab(Tabs.Grid);
    } else if (pathname.includes(ROUTE_PATHS.ACCOUNT_DETAIL_PEOPLE_LIST)) {
      setActiveTab(Tabs.List);
    }
  }, [pathname]);

  return (
    <Switcher solid value={activeTab} size="small" onChange={onChange}>
      <Tooltip title={boardViewName} mouseEnterDelay={0.8}>
        <Switcher.Button
          id="switcher_board"
          value={Tabs.Grid}
          icon={<FontAwesomeIcon icon={faGrid2} />}
          data-cy="all_tasks.switcher_board"
        />
      </Tooltip>
      <Tooltip title={listViewName} mouseEnterDelay={0.8}>
        <Switcher.Button
          id="switcher_list"
          value={Tabs.List}
          icon={<FontAwesomeIcon icon={faList} />}
          data-cy="all_tasks.switcher_list"
        />
      </Tooltip>
    </Switcher>
  );
};
